import { faqItems } from "@/mocks/siteData";

export default function FAQSection() {
  return (
    <section className="py-20 md:py-28 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-0">
          <div className="w-full lg:w-1/2 relative h-64 md:h-80 lg:h-auto min-h-[400px] rounded-2xl lg:rounded-r-none overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Minimalist%20fashion%20flatlay%20with%20white%20sneakers%20and%20denim%20jeans%20on%20light%20mint%20green%20linen%20background%2C%20editorial%20photography%2C%20soft%20natural%20morning%20light%2C%20clean%20fresh%20composition%2C%20question%20mark%20concept&width=900&height=1100&seq=faq-v2-image&orientation=portrait"
              alt="AcBuy Spreadsheet FAQ"
              title="AcBuy Spreadsheet Frequently Asked Questions"
              className="absolute inset-0 w-full h-full object-cover"
              loading="lazy"
            />
            <div className="absolute bottom-0 left-0 right-0 p-8 md:p-10">
              <h2 className="text-3xl md:text-5xl font-heading font-bold text-white leading-tight drop-shadow-lg">
                Got<br />Questions?
              </h2>
            </div>
          </div>

          <div className="w-full lg:w-1/2 bg-white rounded-2xl lg:rounded-l-none p-8 md:p-12 lg:p-14">
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 mb-8">
              Frequently{" "}
              <span className="text-accent-500">Asked Questions</span>
            </h2>

            <div className="space-y-6">
              {faqItems.map((item) => (
                <div key={item.q}>
                  <h4 className="text-base md:text-lg font-semibold text-foreground-900 mb-2">
                    {item.q}
                  </h4>
                  <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                    {item.a}
                  </p>
                </div>
              ))}
            </div>

            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 mt-10 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-white text-sm font-semibold rounded-full transition-colors whitespace-nowrap cursor-pointer"
            >
              Browse Spreadsheet
              <i className="ri-arrow-right-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": faqItems.map((item) => ({
              "@type": "Question",
              "name": item.q,
              "acceptedAnswer": {
                "@type": "Answer",
                "text": item.a,
              },
            })),
          }),
        }}
      />
    </section>
  );
}